import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import TitleContent from '../../TinyComponents/TitleContent';
import CardList from '../../CardList';
import styles from './styles.less';
import ArticleContent from './ArticleContent';

const ArticleBody = ({ title, article, recommended }) => {
  const { t } = React.useContext(LocalizationContext);

  const recommendedComponent = !!recommended && (
    <div className={styles.recommended}>
      <TitleContent
        title={
          <>
            <h2>{t('frontpage.courses.recommended.title')}</h2>
            <p>{t('frontpage.courses.recommended.description')}</p>
          </>
        }
        content={
          <CardList
            data={recommended}
            filters={{ type: 'recommended' }}
            noButton
            reference="article"
          />
        }
      />
    </div>
  );

  return (
    <ArticleContent
      title={`${title || article.title} | ${t('meta.title.suffix')}`}
      article={article || {}}
      recommended={recommendedComponent}
    />
  );
};

ArticleBody.propTypes = {
  article: PropTypes.object.isRequired,
  title: PropTypes.string,
  recommended: PropTypes.array,
};

ArticleBody.defaultProps = {
  title: null,
  recommended: [],
};

export default ArticleBody;
